"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7960],{

/***/ 97960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SMBCardFull": function() { return /* binding */ SMBCardFull; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69417);
/* harmony import */ var _components_feature_searchDirectory_LatestReview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29460);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42660);
/* harmony import */ var _SMBOverview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30125);
/* harmony import */ var _SMBExperienceSummary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89570);
/* harmony import */ var _SMBAttributesTagList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6890);
/* harmony import */ var _helpers_hasPhilosphiesOrSchoolTypes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98804);









var SMBCardFull = function(param) {
    var searchResult = param.searchResult;
    var _seoSegmentationProvider = searchResult.seoSegmentationProvider, _provider = _seoSegmentationProvider.provider, description = _provider.description, id = _provider.id, philosophies = searchResult.philosophies, schoolTypes = searchResult.schoolTypes;
    var fireAnalyticsEvent = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.ctaInteracted */ .Sj.ctaInteracted, {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenName.SEGMENTATION */ .CG.SEGMENTATION,
            cta_text: "See info",
            provider_id: id
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        width: "100%",
        px: 3,
        py: 4,
        borderRadius: 6,
        sx: {
            mt: 4,
            "&:first-of-type": {
                mt: 0
            }
        },
        bgcolor: "background.primary",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SMBOverview__WEBPACK_IMPORTED_MODULE_4__/* .SMBOverview */ .v, {
                searchResult: searchResult
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                display: "flex",
                flexDirection: {
                    xs: "column",
                    sm: "row"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: [
                            (0,_helpers_hasPhilosphiesOrSchoolTypes__WEBPACK_IMPORTED_MODULE_8__/* .hasPhilosophiesOrSchoolTypes */ .e)(philosophies, schoolTypes) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                mt: 3,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SMBAttributesTagList__WEBPACK_IMPORTED_MODULE_6__/* .SMBAttributesTagList */ .n, {
                                    philosphies: philosophies,
                                    schoolTypes: schoolTypes
                                })
                            }),
                            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                mt: 3,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SMBExperienceSummary__WEBPACK_IMPORTED_MODULE_5__/* .SMBExperienceSummary */ .C, {
                                    experienceSummary: description,
                                    providerID: id
                                })
                            }),
                            searchResult.latestReview && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                mt: 3,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_feature_searchDirectory_LatestReview__WEBPACK_IMPORTED_MODULE_1__/* .LatestReview */ .f, {
                                    latestReview: searchResult.latestReview
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        href: searchResult.profileURL,
                        target: "_blank",
                        size: "medium",
                        sx: {
                            minWidth: "160px",
                            ml: 4,
                            alignSelf: "flex-end"
                        },
                        color: "primary",
                        onClick: fireAnalyticsEvent,
                        variant: "contained",
                        children: [
                            "See info",
                            " "
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SMBCardFull);


/***/ })

}]);